<TextCell text={lang.main('Participant_')} header colspan={2} />

<script>
    import TextCell from "@itslearning/prometheus/assets/lists/TextCell/v1/TextCell.svelte";

    import { lang } from "@its-ui/mono/lang/provider";
</script>
